import { Box, Button, useMediaQuery } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { motion } from 'motion/react'
import MobileView from './Mobile'
import DesktopView from './Desktop'
import { BtnsHoverAnimation } from '../../../../utils/animation'

const Index = ({
  children,
  customBtnIcon,
  textBtnStyle,
  customStyle,
  disabled,
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const [popperStatus, setPopperStatus] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(popperStatus)

  const handleToggle = () => {
    setPopperStatus(!popperStatus)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setPopperStatus(false)
  }

  useEffect(() => {
    if (prevOpen.current === true && popperStatus === false) {
      anchorRef?.current.focus()
    }

    prevOpen.current = popperStatus
  }, [popperStatus])

  return (
    <Box sx={styles.changeStatusContainer}>
      <Button
        ref={anchorRef}
        aria-controls={popperStatus ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        sx={[styles.moreActionsButton, customStyle, textBtnStyle && styles.textStyle]}
        onClick={handleToggle}
         disabled={disabled}
        component={motion.button}
        variants={BtnsHoverAnimation}
        whileHover={!disabled && 'hover'}
      >
        { customBtnIcon || <MoreHorizIcon sx={styles.moreHorizIcon} />}
      </Button>
      {isXsScreen ? (
        <MobileView
          popperStatus={popperStatus}
          handleClose={handleClose}
        >
          {children}
        </MobileView>
      ) : (
        <DesktopView
          popperStatus={popperStatus}
          handleClose={handleClose}
          anchorRef={anchorRef}
        >
          {children}
        </DesktopView>
      )}
    </Box>
  )
}
const styles = {
  changeStatusContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    marginRight: '20px',
  },
  moreActionsButton: {
    height: { xs: '30px', sm: '40px' },
    minWidth: { xs: '30px', sm: '40px' },
    borderRadius: '12px',
    border: 'solid 2px #e2e8ee',
    backgroundColor: '#f7f9fb',
    color: 'text.hint',
    overflow: 'hidden',
    padding: '0',
  },
  textStyle: {
    width: '100%',
    border: 0,
    backgroundColor: 'transparent',
    textTransform: 'capitalize',
    color: 'text.primary',
    fontSize: '16px',
  },
  moreHorizIcon: {
    color: 'grey',
  },
}
export default Index
